<div class="progress" *ngIf="isLoading">
	<div class="progress-bar progress-bar-striped progress-bar-animated"
		role="progressbar" aria-valuenow="75" aria-valuemin="0"
		aria-valuemax="100" style="width: 100%">Please wait a moment, ...</div>
</div>
<div id="container" *ngIf="!isLoading">
	<app-headerbar></app-headerbar>
	<router-outlet></router-outlet>
	<app-footer></app-footer>
</div>